import { createFileRoute } from '@tanstack/react-router';
import { AndroidAppDownload } from '@/features/system/AndroidAppDownload';

export const Route = createFileRoute('/_app/app-android')({ component: AndroidAppDownload });
